import i18n from 'i18next'

// redux  - 切换语言中间件
export const changeLanguage = () => next => action => {
    if (action.type === 'HeaderSlice/changeLanguage') {
        // 切换本地语言，写这里是因为 reducer 纯函数原则，尽量不破坏约定
        i18n.changeLanguage(action.payload)
    }
    next(action) // 管道通行，必写
}
